import React, { FC, PropsWithChildren } from 'react';
import { LayoutExplorer } from './LayoutExplorer';

type ExplorerAddressLayoutProps = {
  params: {
    address: string;
    network: string;
  };
};

export const LayoutExplorerAddress: FC<PropsWithChildren<ExplorerAddressLayoutProps>> = ({
  children,
  params: { network, address },
}) => {
  return <LayoutExplorer params={{ network, value: address }}>{children}</LayoutExplorer>;
};
